import WebUserForm from "../../../components/UserManagement/WebUser/WebUserForm";

const WebUserPage = () => {
  return <WebUserForm />;
};

export default WebUserPage;
